import React, { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  IconButton,
  TextField,
  Box,
  Slide // Import Slide for transition
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { useMutation } from "@tanstack/react-query";
import UserQuery from "../../stateQueries/User";
import CircularProgress from "@mui/material/CircularProgress";
import AlertPopup from "../AlertPopup";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const NewsletterModal = ({ open, handleClose }) => {
  const [email, setEmail] = useState("");

  const subscribeMutation = useMutation({
    mutationFn: (email) => UserQuery.subscribeToNewsletter({ email }),
    onSuccess: () => {
      setEmail("");
      setTimeout(() => {
        handleClose();
      }, 2000);
    }
  });

  const handleSubmit = (e) => {
    e.preventDefault();
    subscribeMutation.mutate(email);
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      maxWidth="sm"
      fullWidth
      TransitionComponent={Transition} // Add TransitionComponent
    >
      <DialogTitle sx={{ m: 0, p: 2, backgroundColor: "primary.main" }}>
        <Typography
          variant="h5"
          component="div"
          fontWeight="bold"
          textAlign="center"
          sx={{ color: "white" }}
        >
          Never Miss an Update!
        </Typography>
        <IconButton
          aria-label="close"
          onClick={handleClose}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: "white"
          }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent dividers>
        {subscribeMutation.isSuccess && (
          <AlertPopup
            open={true}
            severity="success"
            message="Successfully subscribed to the newsletter!"
          />
        )}

        {subscribeMutation.isError && (
          <AlertPopup
            open={true}
            severity="error"
            message={
              subscribeMutation.error?.response?.data?.message || "Server Error"
            }
          />
        )}
        <Typography variant="body1" paragraph>
          Get exclusive insights, industry trends, and FASSET updates
        </Typography>
        <Typography variant="body1" paragraph>
          Join thousands of professionals staying ahead in financial services
        </Typography>
        <Box component="form" onSubmit={handleSubmit} sx={{ mt: 2 }}>
          <TextField
            fullWidth
            label="Your Email Address"
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
            sx={{ mb: 2 }}
          />
          <Button
            type="submit"
            variant="contained"
            color="primary"
            fullWidth
            disabled={subscribeMutation.isLoading}
          >
            {subscribeMutation.isLoading ? (
              <CircularProgress size={24} color="inherit" />
            ) : (
              "Subscribe Now"
            )}
          </Button>
        </Box>
        <Typography
          variant="body2"
          sx={{
            mt: 2,
            color: "text.secondary",
            fontSize: "0.875rem",
            fontStyle: "italic",
            textAlign: "center"
          }}
        >
          🔒 100% free • Unsubscribe anytime • No spam
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} color="primary">
          No Thanks
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default NewsletterModal;
